export const STATE_CODES = {
  OHIO: 'US-OH',
};
